export default "__VITE_ASSET__2f403953__"